import {Button, Dialog, DialogActions, DialogContent, DialogTitle} from "@mui/material";
import {EmailActions} from "../../actions/EmailActions";
import {useAppDispatch, useAppSelector} from "../../hooks/ReduxHooks";
import {ContentSafetyResult} from "../../util/SafetyTransformer";
import {ImageWhitelistPreferences} from "../prefs/ImageWhitelistPreferences";
import "./ManageBlockedImagesDialog.scss";
import classNames from "classnames";

interface ManageBlockedImagesDialogProps {
    safetyResult: ContentSafetyResult;
    onSetNoSafety: () => void;
}

export const ManageBlockedImagesDialog = ({
                                              safetyResult,
                                              onSetNoSafety,
                                          }: ManageBlockedImagesDialogProps) => {
    const dispatch = useAppDispatch();

    const open = useAppSelector(s => s.itemState.manageBlockedImagesDialogOpen);

    function onClose() {
        dispatch(EmailActions.setManageBlockedImagesDialogOpen(false));
    }

    function onAllowAll() {
        onClose();
        onSetNoSafety();
    }

    function normaliseUrl(url: string) {
        const queryParamIndex = url.indexOf('?');
        if (queryParamIndex > -1) {
            return [url.substring(0, queryParamIndex), true];
        }
        return [url, false];
    }

    return (
        <Dialog open={open} onClose={onClose} className="manage-blocked-images-dialog">

            <DialogTitle id="alert-dialog-title">Manage Blocked Images</DialogTitle>
            <DialogContent className="edit-email-category-dialog">

                <div>The following images were blocked in this email:</div>
                <div>&nbsp;</div>

                <div className="blocked-url-list">
                    {safetyResult.blockedImages.map(imageUrl => {
                        const [normalisedUrl, wasNormalised] = normaliseUrl(imageUrl);
                        return (
                            <div key={imageUrl} className={classNames("blocked-url", {"normalised-url": wasNormalised})}>
                                {normalisedUrl}
                            </div>
                        );
                    })}
                </div>

                <div>&nbsp;</div>

                <ImageWhitelistPreferences hideHeader/>
            </DialogContent>

            <DialogActions className="archive-dialog-buttons">
                <Button onClick={onAllowAll} color="primary" variant="contained">Allow All</Button>
                <Button onClick={onClose} color="secondary" variant="contained">Close</Button>
            </DialogActions>
        </Dialog>
    );
}
